<template>
<div>
  <div class="waterfall px-container clearfix" v-cloak>
		<ul class="px-waterfall left" v-for="(el,i) in newWaterfallData" :key="i">
			<li v-for="(item,index) in el" :key="index">
				<div style="position: relative;" @click="photo(item.id)">
	                <img :src="item.e_img" style="width: 100%;">
					<div class="chufa" style="width: 100%; height: 98%; position: absolute; top: 0px; background: #000000; z-index: -2;color: #ffffff;">
					  <div style=" width: 90%;height: 30%;position: absolute;z-index: -1;font-size: 16px; text-align: center; bottom: 25%;margin-left: 5%;">{{item.e_intro}}</div>
					</div>
	           	 </div>
			</li>
		</ul>
		
		
		
		
		
		
		<!--a class="c-preview">
		  <div class="c-preview__img"></div>
		  <h2 class="c-preview__title">Gradient Hover Effect 123</h2>
		</a-->
		
	</div>

	<div  v-if="previewImg.popup" style="width: 100%; height: 100%; background: rgba(0, 0, 0, 0.88); position: fixed; top: 0px; left: 0px; z-index: 20;">
		<photo :previewImg="previewImg"></photo>
	</div>
	
</div>
</template>

<script>
import photo from "../../../src/components/photo";
export default {
	components: {
		  photo
	},
  data() {
    return {
		previewImg: {
		        imgList: [
					{
						img:'https://langjian.cnshangji.cn/uploads/allimg/20210930/6e8737fdf80aa181e5a83d4b7a61ac3a.jpg'
					},
					{
						img:'https://langjian.cnshangji.cn/uploads/allimg/20210930/6e8737fdf80aa181e5a83d4b7a61ac3a.jpg'
					},
					{
						img:'https://langjian.cnshangji.cn/uploads/allimg/20210930/0f1093c3b82e2ecf2400d316f49d653f.jpg'
					},
					{
						img:'https://langjian.cnshangji.cn/uploads/allimg/20210930/6e8737fdf80aa181e5a83d4b7a61ac3a.jpg'
					},
				], // 所有图片数组
		        index: 0, // 当前点击的图片的索引
		        infinite: true,  // 是否可以循环切换
		        popup: false // 弹窗的显示隐藏
		      },
      newWaterfallData: '',
      waterfallDataNumber:''
    }
  },
  watch: {  
	  waterfallData:{
	      handler(newValue,oldValue){
			//   this.newWaterfallData = newValue;
			// console.log(newValue);
			// console.log('11222111000')
			
			let [ ...waterfallData ]  = newValue
			let [ ...newWaterfallData ]= [[],[],[],[]]
			waterfallData.forEach((el,i) => {
			  switch( i%4 ) {
			    case 0 : newWaterfallData[0].push(el)
			      break
			    case 1: newWaterfallData[1].push(el)
			      break
			    case 2: newWaterfallData[2].push(el)
			      break
				case 3: newWaterfallData[3].push(el)
				    break
			  }
			});
			this.newWaterfallData = newWaterfallData
			
	      },
	      deep:true //深度监听
	    },
  },
  methods:{
	photo(e){
		console.log(e);
		this.previewImg.popup = true;
		
		this.$http
		  .get(`home/GetByIdlist?id=${e}`)
		  .then(response => {
			console.log(response.data.message);
		    this.previewImg.imgList = response.data.message;
		    window.console.log(this.previewImg.imgList);
			
		  })
		  .catch(function(error) {
		    window.console.log(error);
		  });
		
		
	}  
  },
  created() {

    let [ ...waterfallData ]  = this.waterfallData
    let [ ...newWaterfallData ]= [[],[],[],[]]
    waterfallData.forEach((el,i) => {
      switch( i%4 ) {
        case 0 : newWaterfallData[0].push(el)
          break
        case 1: newWaterfallData[1].push(el)
          break
        case 2: newWaterfallData[2].push(el)
          break
		case 3: newWaterfallData[3].push(el)
		    break
      }
    });
    this.newWaterfallData = newWaterfallData
  },
  props: [ 'waterfallData' ]
}
</script>
<style lang="scss">
	//transition: .5s all;
	

    .px-container {
   		width: 100%;
	  max-width: 100%;
	  margin: 0 auto;
    }
	.clearfix:before,
	.clearfix:after {
	  content: "";
	  display: block;
	  clear: both;
	}
	.clearfix {
	  zoom: 1;
	}
    .left {
    	float: left;
    }
   .font22{
   	font-size:22px;
   } 
   .color-fff {
  	 color:#fff;
   }
    .fh {
    overflow:hidden;
    }
  [v-cloak]{
    display: none!important;
  }
  .waterfall {
    /*margin-top: 20px;*/
  }
  .px-waterfall {
       width: 22%;
    &:nth-child(n) {
      margin-left:2.4%;
    }
    img.bg-img {
      border-radius: 8px;
    }
    h3 {
      text-overflow:ellipsis;
      white-space: nowrap;
      text-overflow: ellipsis;
      height:30px;
      font-family:PingFangSC-Semibold;
      font-weight:600;
      line-height:30px;
      letter-spacing:6px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 999;
    }
    li{
      border-radius: 8px;
      margin-bottom: 20px;
	  cursor: pointer;
	  list-style:none;
    }
	li img:hover{
	  //display: none;
	  transition: 0.8s all;
	  opacity: 0.3;
	}
	// li .chufa:hover{
	//   //display: none;
	//   opacity: 0.2;
	// }
  }
  // .chufa{
  // 	    background: #000;
  // 	    background: -moz-linear-gradient(-45deg, #000000 0%, #000000 25%, #1e539e 50%, #ff3083 75%, #7800a8 100%);
  // 	    /* FF3.6-15 */
  // 	    background: -webkit-linear-gradient(-45deg, #000000 0%, #000000 25%, #1e539e 50%, #ff3083 75%, #7800a8 100%);
  // 	    /* Chrome10-25,Safari5.1-6 */
  // 	    background: linear-gradient(135deg, #000000 0%, #000000 25%, #1e539e 50%, #ff3083 75%, #7800a8 100%);
  // 		  max-width: 100vw;
  // 		  max-height: 100vh;
  // 		  justify-content: center;
  // 		  align-items: center;
  // }

  .px-hot-tag {
    position: absolute;
    top: 0;
    border-radius: 8px;
    width: 71px;
    height: 30px;
    img {
      border-radius: 8px 0 8px 0;
    }
  }
  .photo{
    position: relative;
    height: 25px;
    .keywordbox {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      height: 25px;
    }
  }
  .keyword {
    height: 25px;
    line-height: 25px;
    padding: 0 22px;
    text-align: center;
    .color-666-line {
      border-bottom:2px solid #666666;
    }
    .red-line {
      border-bottom:2px solid #F65050;
    }
  }
</style>
